<template #body="slotProps">
  <div class="card">
    <DataTable
      :value="tableData"
      :rows="rows"
      :paginator="true"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      lazy
      @page="onPaginate"
      :currentPage="currentPage"
      :totalRecords="totalRecords"
    >
      <template #header>
        <div class="search-container">
            <div class="card-toolbar w-full row">
                 <span class="p-input-icon-left ml-4">
              <i class="pi pi-search" />
              <InputText
                  v-model="codeNameModel"
                  placeholder="Rechercher un code"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputCodeName"
              />
            </span>
                <span class="p-input-icon-left ml-4 mr-3">
              <i class="pi pi-search" />
              <InputText
                  v-model="productNameModel"
                  placeholder="Rechercher par produit"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputProductName"
              />
            </span>
                <span class="p-input-icon-left">
                    <FormKit
                        type="autocomplete"
                        name="supplier"
                        placeholder="Sélectionner un fournisseur"
                        :options="searchSuppliers"
                        v-model="supplierModel"
                    />
                </span>
            <span class="p-input-icon-left ml-4">
              <i class="pi pi-search" />
              <InputText
                  v-model="orderNumberModel"
                  placeholder="Rechercher par commande"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputOrderNumber"
              />
            </span>
            </div>
        </div>
      </template>
      <div class="card-body pt-0">
        <Column field="code" header="Code" />
        <Column field="productName" header="Nom du produit" />
        <Column field="productType" header="Type de produit" />
        <Column field="supplierName" header="Fournisseur" />
        <Column field="saleDate" header="Date de vente" />
        <Column field="orderNumber" header="Numéro de commande" />
        <Column field="userName" header="Nom du client" />
      </div>
      <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
  </div>
</template>
<script setup lang="ts">
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import {ref, onMounted, watch} from "vue";
import {FilterMatchMode} from "primevue/api";
import { fetchCodesNotAvailable } from "@/_services/code/code";
import ApiService from "@/_services/api.service";

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);

const rows = ref<number>(10);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];

const codeNameModel = ref<string>("");
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
let productNameModel = ref('');
let supplierModel = ref('');
let orderNumberModel = ref('');

onMounted(async () => {
  await populateDatatable();
});
async function populateDatatable() {
    let paramsFilter = {
        name: codeNameModel.value,
        supplier:supplierModel.value,
        productName: productNameModel.value,
        orderNumber: orderNumberModel.value.trim()
    };
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCodesNotAvailable(rows.value, page.value, paramsFilter);
  isLoading.value = loadingDt.value;
  tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;

}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};

const onFilterDt = () => {
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

watch(
    supplierModel,
    (value) => {
        onFilterDt();
    });

const onClearInputCodeName = () => {
    if (codeNameModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputOrderNumber = () => {
    if (orderNumberModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputProductName= () => {
    if ( productNameModel.value === "" ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};
async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}
</script>
